/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/EditAction",
  onSubmit,
  isSubmitting
  
}) {
let contactMethodAssociationSubmitData = fromData.useDataSubmit({ viewPath,
context: 'contact_method_association',
})
let contactMethodAssociationIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'contact_method_association',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="contact_method_association"
 onClick={contactMethodAssociationSubmitData}
 disabled={contactMethodAssociationIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}